import { Component, OnInit, inject } from '@angular/core';
import { SuggestionEngineService } from '../../../suggestion-engine/suggestion-engine.service';
import { Router } from '@angular/router';
import { BridgeResponse } from '../../../models/suggestion-engine-models';

@Component({
  selector: 'app-top-bridges',
  templateUrl: './topBridges.component.html',
  styleUrls: ['./topBridges.component.scss'],
  standalone: false,
})
export class TopBridgesComponent implements OnInit {
  private ses = inject(SuggestionEngineService);
  private router = inject(Router);

  bridges: any[];
  state = 'loading';

  ngOnInit() {
    this.ses.getTopBridges().subscribe((x: BridgeResponse) => {
      if (x.profiles && x.profiles.length) {
        this.bridges = x.profiles.map(z => {
          return {
            id: z.profile.bridge.bridgeId,
            name: z.profile.bridge.name,
            rank: z.profile.AverageRank,
            score: +z.profile.AverageScore / 10,
            relevant: z.profile.NumRelevant,
          };
        });
        this.state = 'loaded';
      } else if (!x.ClientOpportunities?.Clients) {
        this.state = 'none';
      }
    });
  }

  goToSearch(ev, id) {
    this.router.navigate(['/se/search', { type: 'suggestion', id: id }]);
  }
}
